exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.comment-height{max-height:180px;overflow:scroll\n}\n.makeTop{z-index:99999;position:relative\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/shipper/src/components/common/comments.vue"],"names":[],"mappings":";AACA,gBAAgB,iBAAiB,eAAe;CAC/C;AACD,SAAS,cAAc,iBAAiB;CACvC","file":"comments.vue","sourcesContent":["\n.comment-height{max-height:180px;overflow:scroll\n}\n.makeTop{z-index:99999;position:relative\n}"],"sourceRoot":""}]);

// exports
